<script lang="ts">
	import type { PageData } from './$types';
	import BrandContact from '$lib/components/BrandContact.svelte';
	import BrandSignupCTA from '$lib/components/BrandSignupCTA.svelte';
	import BrandFAQ from '$lib/components/BrandFAQ.svelte';
	import PageContainer from '$lib/components/PageContainer.svelte';

	let { data }: { data: PageData } = $props();
</script>

<svelte:head>
	<title>Contact - {data.config.displayName}</title>
	<meta name="description" content="Get in touch with {data.config.displayName}. We're here to help you succeed." />
	<meta property="og:title" content="Contact - {data.config.displayName}" />
	<meta property="og:type" content="website" />
</svelte:head>

<PageContainer config={data.config}>
	<h1>Contact {data.config.displayName}</h1>

	<div class="intro">
		<p class="lead">
			Have questions about {data.config.productName}? We're here to help you succeed.
		</p>
	</div>

	<div class="top-section">
		<BrandContact config={data.config} />
		<BrandSignupCTA config={data.config} />
	</div>

	<BrandFAQ config={data.config} />
</PageContainer>

<style lang="scss">
	@use "$lib/scss/_mixins.scss" as *;
	@use "$lib/scss/_themes.scss" as *;

	.intro {
		margin-bottom: var(--spacing--section-gap);
		text-align: center;
	}

	.lead {
		font-size: 1.25rem;
		color: #64748b;
		line-height: 1.6;
		margin: 0;
	}

	.top-section {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: var(--spacing--section-gap);
		margin-bottom: var(--spacing--section-gap);
	}

	@media (max-width: 768px) {
		.top-section {
			grid-template-columns: 1fr;
			gap: var(--spacing--element-gap);
		}
	}
</style>
